<template>
  <v-layout wrap>
    <!-- // Diálogo foto {{{ -->
    <v-dialog
      v-model="dialogoAbierto"
      width="340"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Editor de imagen
        </v-card-title>
        <v-card-text>
          <v-layout
            column
            justify-center
          >
            <v-flex>Para cargar su fotografía haga click sobre el cuadro</v-flex>
            <v-flex><strong>Indicaciones:</strong> La imagen debe ser tomada de frente, nítida y con fondo blanco</v-flex>
            <v-layout
              justify-center
              column
            >
              <vue-avatar
                ref="vueavatar"
                :scale="zoom"
                class="justify-center"
                style="margin: auto;"
              />
              <input
                v-model="zoom"
                type="range"
                :min="1"
                :max="10"
              >
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-divider />
      <v-card-actions>
        <v-btn @click="salvarImagen">
          Aceptar
        </v-btn>
        <v-btn @click="dialogoAbierto=false">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-dialog> <!-- //}}} -->

    <v-flex
      :class="activarFotografia?'md10':'md12'"
      xs12
    >
      <!-- //{{{ -->
      <v-layout
        v-model="panel"
        row
        wrap
      >
        <v-flex xs12>
          <!-- Datos textuales {{{ -->
          <v-layout wrap>
            <v-flex
              md6
              xs12
            >
              <v-text-field
                v-model="form.name"
                label="NOMBRES"
                value="name"
                :rules="rules.name"
                :error="!!formErrors.name"
                :error-messages="formErrors.name"
                @keyup="
                  () => {
                    formErrors.name = undefined;
                    delete formErrors.name;
                  }
                "
              />
            </v-flex>
            <v-flex
              md6
              xs12
            >
              <v-text-field
                v-model="form.father_surname"
                label="APELLIDO PATERNO"
                :rules="rules.father_surname"
                :error="!!formErrors.father_surname"
                :error-messages="formErrors.father_surname"
                @keyup="
                  () => {
                    formErrors.father_surname = undefined;
                    delete formErrors.father_surname;
                  }
                "
              />
            </v-flex>
            <v-flex
              sm6
              xs12
            >
              <v-text-field
                v-model="form.mother_surname"
                label="APELLIDO MATERNO"
                :rules="[() => (!!form.foreign_student || !!form.mother_surname) || 'Se requiere el apellido materno' ]"
                :error="!!formErrors.mother_surname"
                :error-messages="formErrors.mother_surname"
                @keyup="
                  () => {
                    formErrors.mother_surname = undefined;
                    delete formErrors.mother_surname;
                  }
                "
              />
            </v-flex>

            <v-flex
              sm3
              xs12
            >
              <v-menu
                ref="menu"
                v-model="targetIssueDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(form.birth_date)"
                    hint="Formato DD/MM/AAAA"
                    label="FECHA DE NACIMIENTO"
                    prepend-icon="event"
                    readonly
                    :rules="rules.birth_date"
                    :error="!!formErrors.birth_date"
                    :error-messages="formErrors.birth_date"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="form.birth_date"
                  min="1940-01-01"
                  max="2007-01-01"
                  :rules="rules.birth_date"
                  :error="!!formErrors.birth_date"
                  :error-messages="formErrors.birth_date"
                  @input="targetIssueDate = false"
                />
              </v-menu>
            </v-flex>
            <v-flex
              sm3
              xs12
            >
              <v-autocomplete
                v-model="form.gender"
                :items="sexo"
                label="SEXO"
                :rules="rules.gender"
                :error="!!formErrors.gender"
                :error-messages="formErrors.gender"
                @keyup="
                  () => {
                    formErrors.gender = undefined;
                    delete formErrors.gender;
                  }
                "
              />
            </v-flex>
            <v-flex
              v-if="mustSelectPlace"
              xs12
            >
              <v-autocomplete
                v-model="form.place"
                :items="places"
                label="Lugar de inscripción (lugar donde rendirá examen)"
                :rules="rules.place"
                :error="!!formErrors.place"
                :error-messages="formErrors.place"
                item-value="id"
                item-text="name"
                @keyup="
                  () => {
                    formErrors.place = undefined;
                    delete formErrors.place;
                  }
                "
              />
            </v-flex>
          </v-layout> <!-- }}} -->
        </v-flex>
      </v-layout> <!-- //}}} -->
    </v-flex> <!-- //}}} -->
    <v-flex
      v-if="activarFotografia"
      sm2
      xs12
      :class="activarFotografia?'sm2':''"
    >
      <h3>Fotografía (Click para abrir)</h3>
      <img
        ref="fotografia"
        width="200"
        height="200"
      >
      <v-btn
        color="primary"
        @click="dialogoAbierto=true"
      >
        Cargar imagen
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
import { VueAvatar } from 'vue-avatar-editor-improved'
import { add, format } from 'date-fns'

export default {
  name: 'AppDatosGenerales001',
  components: {
    VueAvatar
  },
  props: {
    data: {
      required: true, type: Object
    },
    activarFotografia: {
      required: true, type: Boolean, default: true
    },
    pedirRequisitos: {
      required: true, type: Boolean, default: true
    },
    mustSelectPlace: {
      required: true, type: Boolean, default: false
    },
    places: {
      required: false, type: Array, default: []
    }
  },
  data () {
    return {
      step: 1,
      zoom: 1,
      dialogoAbierto: false,
      panel: [false, true],
      formErrors: {},
      sexo: ['Masculino', 'Femenino'],
      form: {
        name: '',
        father_surname: '',
        mother_surname: '',
        // birth_date: format(add(new Date(), {years: -17} ), 'dd/MM/yyyy'),
        birth_date: null,
        gender: '',
        image_data: '',
        place: '',
        foreign_student: false
      },
      targetIssueDate: false,
      targetIssueDateYear: false,
      rules: {
        type_exam_id: [v => !!v || 'Seleccionar modalidad de requerido.'],
        career_id: [v => !!v || 'Seleccionar carrera es requerido.'],
        name: [
				  v => !!v || 'El nombre es requerido.',
				  v => /^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]+$/.test(v) || 'Ingresar solo letras.'
        ],
        father_surname: [
				  v => !!v || 'El apellido paterno es requerido.',
				  v => /^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]+$/.test(v) || 'Ingresar solo letras.'
        ],
        mother_surname: [
				  v => !!v || 'El apellido materno es requerido.',
				  v => /^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]+$/.test(v) || 'Ingresar solo letras.'
        ],
        birth_date: [v => !!v || 'La fecha de nacimiento es requerida.'],
        gender: [v => !!v || 'El dato sexo es requerido.'],
        place: [v => (!!v && this.mustSelectPlace) || 'Sebe seleccionar un lugar de inscripción.']
      }
    }
  },
  computed: {
    validForm () {
      if (this.activarFotografia && !this.form.image_data) {
        this.$message.warning('Debe agregar la fotografía')
        return false
      }
      return !!this.form.name && !!this.form.father_surname &&
        !!this.form.mother_surname && !!this.form.birth_date &&
        !!this.form.gender
    }
  },
  watch: {
    targetIssueDate (val) {
		  val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    targetIssueDateYear (val) {
		  val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    mustSelectPlace (val) {
      // console.log(val);
    },
    places (val) {
      // console.log(val);
    }
  },
  created () {
  },
  methods: {
    formatDate (date) {
		  if (!date) return null
      // return format(date, 'dd/MM/yyy');

		  const [year, month, day] = date.split('-')
		  return `${day}/${month}/${year}`
    },
    getFotografiaDataURL () {
      var canvas = document.createElement('canvas')
      canvas.width = canvas.height = 200
      var ctx = canvas.getContext('2d')
      ctx.drawImage(this.$refs.fotografia, 0, 0)

      const dataURL = canvas.toDataURL('image/jpg')
      return dataURL.replace(/^data:(.*);base64,/, '')
    },
    salvarImagen () {
      this.tieneImagen = true

      this.$refs.fotografia.src =
				this.$refs.vueavatar.getImageScaled().toDataURL()
      this.dialogoAbierto = false
      this.form.image_data = this.getFotografiaDataURL()
    }
  }
}
</script>
